export default "__VITE_ASSET__BWfwFLxI__"